import { WEBSITE_URL } from "./website";

const baseUrl = WEBSITE_URL + "/public";

/** Reference asset base URL: when set, /assets/... paths are loaded from this origin. Use so assets refer directly to reference (e.g. app.dittomart.in) instead of base. Override via localStorage "referenceAssetBaseUrl" (set to empty string to use base assets). */
export const REFERENCE_ASSET_BASE_URL = "https://app.dittomart.in";

export const GET_BRANDS_URL = baseUrl + "/api/brands";
export const GET_SETTINGS_URL = baseUrl + "/api/get-settings";
export const GET_PICK_AND_DROP_SETTINGS_URL = baseUrl + "/api/pickup-and-drop-settings";
export const PND_CART_DETAILS_URL = baseUrl + "/api/pickup-and-drop/cart-details";
export const PND_PLACE_ORDER_URL = baseUrl + "/api/pickup-and-drop-place-order";
export const SEARCH_LOCATIONS_URL = baseUrl + "/api/search-location";
export const GET_POPULAR_LOCATIONS_URL = baseUrl + "/api/popular-geo-locations";
export const GET_PROMO_SLIDER_URL = baseUrl + "/api/promo-slider";
export const GET_OFFERS_URL = baseUrl + "/api/get-offers";
export const GET_DELIVERY_RESTAURANTS_URL = baseUrl + "/api/get-delivery-restaurants";
export const GET_SELFPICKUP_RESTAURANTS_URL = baseUrl + "/api/get-selfpickup-restaurants";
export const GET_RESTAURANT_INFO_URL = baseUrl + "/api/get-restaurant-info";
export const GET_RESTAURANT_INFO_BY_ID_URL = baseUrl + "/api/get-restaurant-info-by-id";
export const GET_RESTAURANT_INFO_AND_OPERATIONAL_STATUS_URL =
baseUrl + "/api/get-restaurant-info-and-operational-status";
export const GET_MEAT_CATEGORIES_URL = baseUrl + "/api/get-meats-categories";
export const GET_CATEGORY_ITEMS_URL = baseUrl + "/api/get-category-items";
export const GET_RESTAURANT_ITEMS_URL = baseUrl + "/api/get-restaurant-items";
export const GET_RECOMMENDED_ITEMS_URL = baseUrl + "/api/get-recommended-items";
export const APPLY_COUPON_URL = baseUrl + "/api/apply-coupon";
export const GET_CART_COUPON_URL = baseUrl + "/api/get-cart-coupon";
export const USER_COUPON_URL = baseUrl + "/api/user-coupons";
export const LOGIN_USER_URL = baseUrl + "/api/login";
export const REGISTER_USER_URL = baseUrl + "/api/register";
export const DELETE_MY_ACCOUNT_URL = baseUrl + "/api/delete-my-account";

//export const GET_PAGES_URL = baseUrl + "/api/get-pages";

//
export const GET_PAGES_URL = baseUrl + "/api/brand/{domain}/policies"
export const GET_SINGLE_PAGE_URL = baseUrl + "/api/get-single-page";
export const SEARCH_RESTAURANTS_URL = baseUrl + "/api/search-restaurants";
export const GET_ADDRESSES_URL = baseUrl + "/api/get-addresses";
export const SAVE_ADDRESS_URL = baseUrl + "/api/save-address";
export const DELETE_ADDRESS_URL = baseUrl + "/api/delete-address";
export const UPDATE_USER_INFO_URL = baseUrl + "/api/update-user-info";
export const CHANGE_USER_AVATAR_URL = baseUrl + "/api/change-avatar";
export const CHECK_BAN_URL = baseUrl + "/api/check-ban";
export const PLACE_ORDER_URL = baseUrl + "/api/place-order";
export const SET_DEFAULT_URL = baseUrl + "/api/set-default-address";
export const GET_ORDERS_URL = baseUrl + "/api/get-orders";
export const GET_BRAND_ORDERS_URL = baseUrl + "/api/brand";
export const GET_PAYMENT_GATEWAYS_URL = baseUrl + "/api/get-payment-gateways";
export const NOTIFICATION_TOKEN_URL = baseUrl + "/api/save-notification-token";
export const SEND_OTP_URL = baseUrl + "/api/send-otp";
export const VERIFY_OTP_URL = baseUrl + "/api/verify-otp";

export const RAZORPAY_CREATE_ORDER_URL = baseUrl + "/api/payment/razorpay/create-order";
export const RAZORPAY_PROCESS_VERIFY_URL = baseUrl + "/api/payment/razorpay/process";

export const PAYU_CREATE_ORDER_URL = baseUrl + "/api/payment/payu/create-order";
export const PAYU_PROCESS_VERIFY_URL = baseUrl + "/api/payment/verify-payu-money";

export const PHONEPE_CREATE_ORDER_URL = baseUrl + "/api/payment/phonepe/create-order";

export const PAYTM_PAYMENT_URL = baseUrl + "/api/payment/paytm";
export const UPI_GATEWAY_PAYMENT_URL = baseUrl + "/api/payment/upi-gateway";

export const CHECK_USER_RUNNING_ORDER_URL = baseUrl + "/api/check-running-order";
export const GET_ORDER_CANCEL_URL = baseUrl + "/api/cancel-order";
export const GET_WALLET_TRANSACTIONS_URL = baseUrl + "/api/get-wallet-transactions";
export const CHECK_RESTAURANT_OPERATION_SERVICE_URL = baseUrl + "/api/check-restaurant-operation-service";
export const GET_SINGLE_ITEM_URL = baseUrl + "/api/get-single-item";
export const GET_ALL_LANGUAGES_URL = baseUrl + "/api/get-all-languages";
export const GET_SINGLE_LANGUAGE_DATA_URL = baseUrl + "/api/get-single-language";
export const GET_ADDRESS_FROM_COORDINATES = baseUrl + "/api/coordinate-to-address";
export const SEND_PASSWORD_RESET_EMAIL_URL = baseUrl + "/api/send-password-reset-mail";
export const VERIFY_PASSWORD_RESET_OTP_URL = baseUrl + "/api/verify-password-reset-otp";
export const CHANGE_USER_PASSWORD_URL = baseUrl + "/api/change-user-password";
export const GET_RESTAURANTS_CATEGORIES_URL = baseUrl + "/api/get-all-restaurants-categories";
export const GET_FILTERED_RESTAURANTS_URL = baseUrl + "/api/get-filtered-restaurants";
export const GET_RESTAURANTS_SLIDES_URL = baseUrl + "/api/get-restaurant-category-slides";
export const GET_ALERTS_URL = baseUrl + "/api/get-user-notifications";
export const MARK_ALL_NOTIFICATIONS_READ_URL = baseUrl + "/api/mark-all-notifications-read";
export const MARK_ONE_NOTIFICATION_READ_URL = baseUrl + "/api/mark-one-notification-read";
export const CHECK_CART_ITEMS_AVAILABILITY_URL = baseUrl + "/api/check-cart-items-availability";

export const STRIPE_PAYMENT = baseUrl + "/api/accept-stripe-payment";
export const STRIPE_PAYMENT_CAPTURE = baseUrl + "/api/stripe-redirect-capture";

export const PAYMONGO_PAYMENT_URL = baseUrl + "/api/payment/process-paymongo";

export const MERCADOPAGO_PAYMENT_URL = baseUrl + "/api/payment/process-mercado-pago";

export const KHALTI_PAYMENT_VERIFICATION_URL = baseUrl + "/api/payment/verify-khalti-payment";

export const GET_REVIEWS_OF_STORE_URL = baseUrl + "/api/get-store-reviews";
export const GET_SINGLE_ORDER_TO_BE_RATED = baseUrl + "/api/single-ratable-order";
export const GET_RATABLE_ORDER_DETAILS_URL = baseUrl + "/api/get-ratable-order";
export const ADD_RATING_URL = baseUrl + "/api/rate-order";
export const ADD_TO_FAVORITE_RESTAURANT_URL = baseUrl + "/api/toggle-favorite";
export const GET_FAVORITE_RESTAURANTS_URL = baseUrl + "/api/get-favorite-stores";
export const GET_FAVORITE_RESTAURANT_FOR_LOGGED_IN_URL = baseUrl + "/api/get-restaurant-info-with-favourite";
export const SAVE_VAT_NUMBER_URL = baseUrl + "/api/update-tax-number";

export const LOGIN_USER_WITH_OTP_URL = baseUrl + "/api/login-with-otp";
export const GENERATE_OTP_FOR_LOGIN_URL = baseUrl + "/api/generate-otp-for-login";
export const GENERATE_OTP_FOR_PHONE_NUMBER_UPDATE_URL = baseUrl + "/api/generate-otp-phone-number-update";
export const UPDATE_PROFILE_URL = baseUrl + "/api/update-user-profile";
export const UPDATE_NEW_PHONE_NUMBER_URL = baseUrl + "/api/update-new-phone-number";

/* Delivery URLs */
export const LOGIN_DELIVERY_USER_URL = baseUrl + "/api/delivery/login";
export const UPDATE_DELIVERY_USER_INFO_URL = baseUrl + "/api/delivery/update-user-info";
export const GET_DELIVERY_ORDERS_URL = baseUrl + "/api/delivery/get-delivery-orders";
export const GET_SINGLE_DELIVERY_ORDER_URL = baseUrl + "/api/delivery/get-single-delivery-order";
export const SEND_DELIVERY_GUY_GPS_LOCATION_URL = baseUrl + "/api/delivery/set-delivery-guy-gps-location";
export const GET_DELIVERY_GUY_GPS_LOCATION_URL = baseUrl + "/api/delivery/get-delivery-guy-gps-location";
export const ACCEPT_TO_DELIVER_URL = baseUrl + "/api/delivery/accept-to-deliver";
export const PICKEDUP_ORDER_URL = baseUrl + "/api/delivery/pickedup-order";
export const DELIVER_ORDER_URL = baseUrl + "/api/delivery/deliver-order";
export const TOGGLE_DELIVERY_GUY_STATUS_URL = baseUrl + "/api/delivery/toggle-delivery-guy-status";
export const DELIVERY_COMPLETED_ORDERS_URL = baseUrl + "/api/delivery/get-completed-orders";

/* Module URLs*/
export const ADMIN_LOGIN_AS_CUSTOMER_URL = baseUrl + "/public/callandorder/login-as-customer";
export const REGISTER_GUEST_USER_URL = baseUrl + "/public/callandorder/register-guest-user";

/* Single Store / Brand URLs */
export const GET_STORE_CONFIG_URL = baseUrl + "/api/store-config";
export const GET_STORE_BY_SLUG_URL = baseUrl + "/api/store-by-slug";
export const GET_BRAND_LOCATIONS_URL = baseUrl + "/api/brand-locations";
export const GET_RESTAURANT_SLIDERS_URL = baseUrl + "/api/restaurant-sliders";

/* Brand-Scoped URLs - Only show restaurants assigned to brand */
export const GET_BRAND_DELIVERY_RESTAURANTS_URL = baseUrl + "/api/brand";
export const GET_BRAND_SELFPICKUP_RESTAURANTS_URL = baseUrl + "/api/brand";
export const SEARCH_BRAND_RESTAURANTS_URL = baseUrl + "/api/brand";
export const GET_BRAND_FILTERED_RESTAURANTS_URL = baseUrl + "/api/brand";